import React, {FunctionComponent, useEffect, useState} from 'react';
import {
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer,
  BarChart,
  Bar
} from 'recharts';
import {IStoreChart} from '../../redux/staistics-dashboard/interfaces';

import './styles.scss';

interface IStatisticsBarChart {
  chart: IStoreChart;
}

export const StatisticsBarChart: FunctionComponent<IStatisticsBarChart> = ({chart}) => {
  const [chartData, setChartData] = useState<Array<{name: string; value: number}>>([]);

  const COLOR = '#56B4E9';

  useEffect(() => {
    if (!chart || !Array.isArray(chart.labels) || !Array.isArray(chart.series)) {
      setChartData([]);

      return;
    }

    const rows = chart.labels.map((label, i) => {
      const raw = chart.series[i];
      const num = raw === undefined || raw === null || raw === '' ? undefined : Number(raw);

      return {name: label, value: Number.isFinite(num) ? (num as number) : 0};
    });

    setChartData(rows);
  }, [chart]);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar name="Series" dataKey="value" fill={COLOR} radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
